import React from 'react';
import { CheckIcon, UsersIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { PRECIOS, PAGO_LINK, RESERVA_LINK } from '../../data/retiro';
export function Inversion() {
  return <section id="inversion" className="relative w-full overflow-hidden px-5 py-24 sm:px-8 sm:py-32" style={{
    backgroundColor: 'var(--ink)'
  }} data-id="element-183" data-mp="26f9girqrkiit">
      <div className="mx-auto max-w-5xl" data-id="element-184" data-mp="2fghd95dmtbas">
        <SectionHeading eyebrow="Inversión" title="Reserva tu plaza" subtitle="26 de noviembre al 1 de diciembre · 4 noches en Akalki, Bacalar + 1 noche en Cancún" light data-id="element-185" data-mp="2bgp0egh7gizm" />

        <div className="mt-16 grid gap-6 md:grid-cols-3" data-id="element-186" data-mp="2k8h5scrdh1xc">
          {PRECIOS.map((p, i) => <Reveal key={p.concepto} delay={i * 0.1} data-id="element-187" data-mp="2z5892x462xs8" data-mpi={i}>
              <div className="flex h-full flex-col rounded-3xl border border-white/10 bg-white/[0.04] p-8 text-center" data-id="element-188" data-mp="2z3x81523w44t">
                <span className="text-3xl" data-id="element-189" data-mp="3ifkxp5lth7d4">{p.emoji}</span>
                <p className="mt-4 text-sm uppercase tracking-wide text-white/60" data-id="element-190" data-mp="3ih5smwc1msbi">
                  {p.concepto}
                </p>
                <p className="mt-2 font-heading text-3xl font-light" style={{
              color: 'var(--jasmine)'
            }} data-id="element-191" data-mp="3rg98zsjtstmb">
                  {p.valor}
                </p>
              </div>
            </Reveal>)}
        </div>

        <Reveal delay={0.15} data-id="element-192" data-mp="a7w3z62x2ty5">
          <div className="mt-8 flex flex-col items-center gap-3 rounded-3xl p-8 text-center" style={{
          backgroundColor: 'var(--darkgoldenrod)'
        }} data-id="element-193" data-mp="a7477rxl2q6a">
            <span className="text-sm font-medium uppercase tracking-[0.2em] text-white/80" data-id="element-194" data-mp="iz65pko3dwdx">
              📌 Separación de cupo
            </span>
            <p className="font-heading text-4xl font-light text-white" data-id="element-195" data-mp="syn89t81ru5o">
              444 USD
            </p>
            <p className="max-w-md text-sm text-white/85" data-id="element-196" data-mp="2p1ify30pgzig">
              Aseguras tu lugar con 444 dólares estadounidenses. El resto lo
              coordinamos juntas, con amor y claridad.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.2} data-id="element-197" data-mp="2ysd4je1fcb72">
          <div className="mt-10 flex flex-col items-center gap-6" data-id="element-198" data-mp="2yto93g2p1mz8">
            <p className="inline-flex items-center gap-2 text-center text-sm text-white/70" data-id="element-199" data-mp="2u039jjlgckxx">
              <UsersIcon className="h-4 w-4 shrink-0" style={{
              color: 'var(--jasmine)'
            }} data-id="element-200" data-mp="37qykd1fihc45" />
              Cupo limitado a 15 personas · Un espacio íntimo y contenido, no un
              evento masivo
            </p>
            <a href={PAGO_LINK} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full px-10 py-4 text-sm font-medium transition-transform hover:scale-[1.04]" style={{
            backgroundColor: 'var(--jasmine)',
            color: 'var(--ink)'
          }} data-id="element-201" data-mp="3cse32mu7v6jd">
              <CheckIcon className="h-4 w-4" data-id="element-202" data-mp="2tcavq4h375y" />
              Separar mi cupo con 444 USD
            </a>
            <a href={RESERVA_LINK} target="_blank" rel="noreferrer" className="text-sm text-white/70 underline underline-offset-4 transition-opacity hover:opacity-100 hover:text-white" data-id="element-203" data-mp="3k9u9barbj356">
              ¿Tienes preguntas? Escríbenos por WhatsApp
            </a>
          </div>
        </Reveal>
      </div>
    </section>;
}